import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Page} from '../../core/pagination/page';
import {PageRequest} from '../../core/pagination/page-request';
import {SortOrder} from '../../core/sort/sort-order';
import {Prestatie} from '../prestatie';
import {Thuisverzorger} from '../../thuisverzorger/thuisverzorger';

@Component({
    selector: 'zah-prestaties',
    templateUrl: './prestaties.component.html',
    styleUrls: ['./prestaties.component.scss'],
    standalone: false
})
export class PrestatiesComponent implements OnInit {

  @Input()
  initialPageRequest: PageRequest<Prestatie>;
  @Input()
  prestatiesPage: Page<Prestatie>;
  @Input()
  thuisverzorgers: Array<Thuisverzorger>;
  @Output()
  prestatieClicked: EventEmitter<Prestatie> = new EventEmitter<Prestatie>();
  @Output()
  pageChange: EventEmitter<PageRequest<Prestatie>> = new EventEmitter<PageRequest<Prestatie>>();

  private currentPageRequest: PageRequest<Prestatie>;

  ngOnInit(): void {
    this.currentPageRequest = this.initialPageRequest;
  }

  getThuisverzorger(id: string): Thuisverzorger {
    return this.thuisverzorgers.find(thuisverzorger => thuisverzorger.hasId(id));
  }

  onPrestatieClick(prestatie: Prestatie): void {
    this.prestatieClicked.emit(prestatie);
  }

  onSortOrderChange(sortOrder: SortOrder): void {
    this.currentPageRequest = PageRequest.firstPageRequest<Prestatie>(sortOrder, this.currentPageRequest.getPageSize());
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageSizeChange(pageSize: number): void {
    this.currentPageRequest = PageRequest.firstPageRequest<Prestatie>(this.currentPageRequest.getSortOrder(), pageSize);
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageChange(pageRequest: PageRequest<Prestatie>): void {
    this.currentPageRequest = pageRequest;
    this.pageChange.emit(pageRequest);
  }
}
